import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, message, Alert } from 'antd';
import { useNavigate } from 'react-router-dom';
import { updateProfile } from '../services/api';

const { Title } = Typography;

function ProfilePage() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const username = localStorage.getItem('username') || '';

  const onFinish = async (values) => {
    if (!values.username && !values.password) {
      message.warning('请至少修改一项内容');
      return;
    }

    setLoading(true);
    try {
      const data = { current_password: values.current_password };
      if (values.username) data.username = values.username;
      if (values.password) data.password = values.password;

      await updateProfile(data);
      message.success('修改成功，请重新登录');
      localStorage.removeItem('token');
      localStorage.removeItem('username');
      setTimeout(() => navigate('/login'), 1000);
    } catch (err) {
      message.error(err.response?.data?.error || '修改失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 500 }}>
      <Title level={4}>个人设置</Title>

      <Alert
        message="修改用户名或密码后需要重新登录"
        type="info"
        showIcon
        style={{ marginBottom: 24 }}
      />

      <Card>
        <Form
          layout="vertical"
          onFinish={onFinish}
          initialValues={{ username: '' }}
        >
          <Form.Item label="当前用户名">
            <Input value={username} disabled />
          </Form.Item>

          <Form.Item
            name="username"
            label="新用户名"
            help="留空则不修改"
          >
            <Input placeholder="输入新用户名" />
          </Form.Item>

          <Form.Item
            name="password"
            label="新密码"
            help="留空则不修改，最少6位"
            rules={[
              { min: 6, message: '密码最少6位' }
            ]}
          >
            <Input.Password placeholder="输入新密码" />
          </Form.Item>

          <Form.Item
            name="confirm_password"
            label="确认新密码"
            dependencies={['password']}
            rules={[
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('两次输入的密码不一致'));
                },
              }),
            ]}
          >
            <Input.Password placeholder="再次输入新密码" />
          </Form.Item>

          <Form.Item
            name="current_password"
            label="当前密码 (验证身份)"
            rules={[{ required: true, message: '请输入当前密码' }]}
          >
            <Input.Password placeholder="输入当前密码以验证身份" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading}>
              保存修改
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}

export default ProfilePage;
